export default {
  namespaced: true,
  state: {
    visible: false,
    title: '',
    message: '',
    type: '',
    resolve: null,
    reject: null,
  },
  getters: {
    dialogVisible: (state) => state.visible,
    dialogTitle: (state) => state.title,
    dialogContent: (state) => state.message,
    dialogType: (state) => state.type,
  },
  mutations: {
    SHOW_DIALOG(state, { title, message, type, resolve, reject }) {
      state.visible = true;
      state.title = title || '';
      state.message = message;
      state.type = type;
      state.resolve = resolve;
      state.reject = reject;
    },
    HIDE_DIALOG(state) {
      state.visible = false;
      state.title = '';
      state.message = '';
      state.type = '';
      state.resolve = null;
      state.reject = null;
    },
  },
  actions: {
    showDialog({ commit }, { title, message, type }) {
      return new Promise((resolve, reject) => {
        commit('SHOW_DIALOG', { title, message, type, resolve, reject });
      });
    },
    hideDialog({ commit }) {
      commit('HIDE_DIALOG');
    },
    confirm({ state, dispatch }) {
      if (state.resolve) state.resolve();
      dispatch('hideDialog');
    },
    cancel({ state, dispatch }) {
      if (state.reject) state.reject();
      dispatch('hideDialog');
    },
  }
}
